export default __webpack_public_path__ + "static/media/Educating2.1055b3e1.jpg";